
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/comparisons/frame-io-pricing",
      function () {
        return require("private-next-pages/comparisons/frame-io-pricing.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/comparisons/frame-io-pricing"])
      });
    }
  